<script setup lang="ts">
import Toast from '@/components/Toast.vue'
</script>

<template>
  <router-view />
  <Toast />
</template>
